export default __webpack_public_path__ + "svg/CompaniesLogos/logo-acceseo_svg.svg?0ff53214";